angular.module("avant.customer_applications.factories").factory "ValidationsRequiredHelper", ->

  dictionary = null

  openDictionary = ->
    dictionary = {}

  closeDictionary = ->
    dictionary = null

  writeToDictionary = (field, value) ->
    dictionary[field] = value

  readFromDictionary = (field) ->
    dictionary[field]

  withDictionary = (callable) ->
    if dictionary?
      console.warn("withDictionary called when dictionary is already open")
    else
      openDictionary()
    try
      callable()
    finally
      closeDictionary()

  logDictionary = (prefix)->
    console.log("Requirement Dictionary | #{prefix}: ", dictionary)

  return {
    openDictionary: openDictionary,
    closeDictionary: closeDictionary,
    writeToDictionary: writeToDictionary,
    readFromDictionary: readFromDictionary,
    logDictionary: logDictionary,
    withDictionary: withDictionary
  }
